import { render, staticRenderFns } from "./InsuranceRow.vue?vue&type=template&id=0f37bc61&"
import script from "./InsuranceRow.vue?vue&type=script&lang=js&"
export * from "./InsuranceRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports